var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Issues"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 5C8.23122 5 7 6.23122 7 7.75V13.75C7 15.2688 8.23122 16.5 9.75 16.5H17.75C19.2688 16.5 20.5 15.2688 20.5 13.75V7.75C20.5 6.23122 19.2688 5 17.75 5H9.75ZM8.5 7.75C8.5 7.05964 9.05965 6.5 9.75 6.5H17.75C18.4404 6.5 19 7.05964 19 7.75V13.75C19 14.4404 18.4404 15 17.75 15H9.75C9.05965 15 8.5 14.4404 8.5 13.75V7.75ZM14.4926 8.67497C14.4926 8.26075 14.1568 7.92497 13.7426 7.92497C13.3284 7.92497 12.9926 8.26075 12.9926 8.67497V10.358C12.9926 10.7722 13.3284 11.108 13.7426 11.108C14.1568 11.108 14.4926 10.7722 14.4926 10.358V8.67497ZM13.7428 12.9618C13.7981 12.9618 13.8287 12.9186 13.8287 12.8828C13.8287 12.847 13.7981 12.8039 13.7428 12.8039C13.6876 12.8039 13.657 12.847 13.657 12.8828C13.657 12.9186 13.6876 12.9618 13.7428 12.9618ZM12.8287 12.8828C12.8287 12.382 13.2302 11.9618 13.7428 11.9618C14.2555 11.9618 14.657 12.382 14.657 12.8828C14.657 13.3837 14.2555 13.8039 13.7428 13.8039C13.2302 13.8039 12.8287 13.3837 12.8287 12.8828ZM6 7.75C6 7.33579 5.66421 7 5.25 7C4.83579 7 4.5 7.33579 4.5 7.75V14.25C4.5 16.8734 6.62665 19 9.25 19H17.25C17.6642 19 18 18.6642 18 18.25C18 17.8358 17.6642 17.5 17.25 17.5H9.25C7.45507 17.5 6 16.0449 6 14.25V7.75Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssues);
export default __webpack_public_path__ + "static/media/Issues.7c3bfacd080c58b06d085c56aabd02c9.svg";
export { ForwardRef as ReactComponent };